import React from "react";

import { useTranslation } from "react-i18next";
import { Stack } from '@fluentui/react';
import { DefaultButton } from '@fluentui/react/lib/Button';

const SAdminProfileOptionButtons = (props) => {

    const { t } = useTranslation();

    const listItems = props.items;
    const { disabled, checked } = props;
    const stackTokens = { childrenGap: 40 };
    
    let menuProps = {
        items: []
    };

    listItems.map((item, index) => {
        if (item.show) {
            menuProps.items.push({
                key: item.key,
                text: item.text,
                iconProps: { iconName: item.iconName },
                className: "ms-Icon-custom",
                onClick: item.onClick,
            });
        }
    });    
    
    return (
        <div data-html2canvas-ignore="true" className="ms-auto mt-1">
            <Stack horizontal wrap tokens={stackTokens}>
                <DefaultButton
                    text={t('data-lang-lbl-reports')}
                    primary
                    split
                    onClick={null}
                    menuProps={menuProps}
                    disabled={disabled}
                    checked={checked}
                />
            </Stack>
        </div>
    );
};

export default SAdminProfileOptionButtons;


